import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import "./sign.css";
import "./App.css";
function App() {
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [dish, setDish] = useState(localStorage.getItem("dish") || "");
  const [isLoading, setIsLoading] = useState(false);
  const [ingredients, setIngredients] = useState([]);
  const [instructions, setInstructions] = useState([]);
  const [isProcessing] = useState(false);
  const [nutritionInfo, setNutritionInfo] = useState(null);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [exceptIngredients, setExceptIngredients] = useState([]);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const jumpToProfile = () => {
    window.location.href = "/Profile";
  };

  const jumpToHome = () => {
    window.location.href = "/Home";
  };

  const handleGPT = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const checkedAppliances = Object.keys(checkedItems).filter(
      (key) => checkedItems[key] === true
    );
    const checkedAppliancesString = checkedAppliances.join(",");
    const selectedIngredientsString = selectedIngredients
      .map((ingredient) => ingredient.value)
      .join(",");
    const exceptIngredientsString = exceptIngredients
      .map((ingredient) => ingredient.value)
      .join(",");
    try {
      const res = await fetch(
        `https://mv4sn7izfeq5dux2rrosyhe5qu0dfcto.lambda-url.ca-central-1.on.aws?prompt=${dish}&checkedAppliances=${checkedAppliancesString}&selectedIngredients=${selectedIngredientsString}&exceptIngredients=${exceptIngredientsString}`,

        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      console.log(data); // Check the structure of the data

      // Split the response into an array, divided by "Instructions:"
      const recipeSections = data.recipe.split("Instructions:");
      const ingredients = recipeSections[0];
      const instructions = recipeSections[1];

      // Remove leading and trailing whitespaces, the word "Ingredients:" and replace newlines with <br />
      const formattedIngredients = ingredients
        .replace("Ingredients:", "") // Remove "Ingredients:"
        .trim()
        .split("\n")
        .map((ing) => ing.replace("-", "").trim())
        .filter((ing) => ing !== ""); // Filter out any empty strings

      const formattedInstructions = instructions
        .trim()
        .split("\n")
        .map((ins) => ins.trim())
        .filter((ins) => ins !== ""); // Filter out any empty strings

      console.log("Formatted Ingredients:", formattedIngredients);
      console.log("Formatted Instructions:", formattedInstructions);

      // Get the nutrition info
      const nutritionInfo = data.nutrition_info;

      // Set the state with the formatted strings and nutrition info
      setIngredients(formattedIngredients);
      setInstructions(formattedInstructions);
      setNutritionInfo(nutritionInfo);
    } catch (error) {
      console.error("Failed to fetch recipe:", error);
    } finally {
      setIsLoading(false);
    }
    console.log("nutritionInfo", nutritionInfo);
  };
  const handleChange = (e) => {
    const { name, checked } = e.target;

    setCheckedItems({
      ...checkedItems,
      [name]: checked,
    });
  };

  const loadOptions = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      return;
    }
    try {
      const res = await fetch(
        `https://api.edamam.com/api/food-database/v2/parser?ingr=${inputValue}&app_id=28692970&app_key=b18bc309cd3ea587e3e616709a1617f0`
      );
      const data = await res.json();
      if (data.hints.length > 0) {
        const ingredients = data.hints.map((hint) => ({
          value: hint.food.label,
          label: hint.food.label,
        }));
        const filteredIngredients = ingredients.filter(
          (ingredient) =>
            !selectedIngredients.find(
              (selected) => selected.value === ingredient.value
            )
        );
        callback(filteredIngredients);
      }
    } catch (error) {
      console.error("Failed to search ingredients:", error);
    }
  };
  const handleIngredientChange = (newValue) => {
    setSelectedIngredients((prevIngredients) => [...prevIngredients, newValue]);
  };
  const handleDeleteIngredient = (indexToDelete) => {
    const newSelectedIngredients = selectedIngredients.filter(
      (_, index) => index !== indexToDelete
    );
    setSelectedIngredients(newSelectedIngredients);
  };
  const handleDeleteIngredientexcept = (indexToDelete) => {
    const newSelectedIngredients = exceptIngredients.filter(
      (_, index) => index !== indexToDelete
    );
    setExceptIngredients(newSelectedIngredients);
  };
  const handleexceptIngredientChange = (newValue) => {
    if (exceptIngredients in selectedIngredients) {
      alert("You cant add same ingredient in both included and excluded list");
      return;
    }
    setExceptIngredients((prevIngredients) => [...prevIngredients, newValue]);
  };
  const appliances = [
    { label: "Stove", name: "stove" },
    { label: "Oven", name: "oven" },
    { label: "Microwave", name: "microwave" },
    { label: "BBQ", name: "bbq" },
    { label: "Air Fryer", name: "airfryer" },
    { label: "Blender", name: "blender" },
    { label: "Slow Cooker", name: "slowcooker" },
    { label: "Rice Cooker", name: "ricecooker" },
    { label: "Pressure Cooker", name: "pressurecooker" },
    { label: "Toaster", name: "toaster" },
  ];

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>Chefs Kiss</h1>
          </div>
          <div className="navbar-user">
            <button
              className="home"
              onClick={() => {
                jumpToHome();
              }}
            >
              Home
            </button>
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToProfile();
              }}
            >
              {username}
            </button>
            <button
              className="btn btn-logout"
              onClick={() => {
                setIsSignIn(false);
                setEmail("");
                setUsername("");
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="main-container">
        <div className="content-wrapper">
          <h1>ChatGPT-Integrated Recipe Maker</h1>
          <div className="search-dish">
            <form onSubmit={handleGPT}>
              {dish ? (
                <input
                  type="text"
                  className="input-gpt"
                  placeholder="Enter the dish name here..."
                  value={dish}
                  onChange={(e) => setDish(e.target.value)}
                />
              ) : (
                <input
                  type="text"
                  className="input-gpt"
                  placeholder="Enter the dish name here..."
                  onChange={(e) => setDish(e.target.value)}
                />
              )}
            </form>
            <div className="submit-button">
              <button className="btn-submit" onClick={handleGPT}>
                Submit
              </button>
            </div>
          </div>
          <div className="checkbox-main">
            <div className="checkbox-container">
              <div className="checkbox-header">
                <h2>Appliances:</h2>
              </div>
              <div className="checkbox-item">
                <div className="column1">
                  {appliances.slice(0, 5).map((appliance) => (
                    <div key={appliance.name}>
                      <label
                        htmlFor={appliance.name}
                        style={{
                          color: checkedItems[appliance.name]
                            ? "#007BFF"
                            : "inherit",
                        }}
                      >
                        {appliance.label}
                      </label>
                      <input
                        type="checkbox"
                        id={appliance.name}
                        name={appliance.name}
                        value={appliance.name}
                        onChange={handleChange}
                      />
                    </div>
                  ))}
                </div>
                <div className="column2">
                  {appliances.slice(5).map((appliance) => (
                    <div key={appliance.name}>
                      <label
                        htmlFor={appliance.name}
                        style={{
                          color: checkedItems[appliance.name]
                            ? "#007BFF"
                            : "inherit",
                        }}
                      >
                        {appliance.label}
                      </label>
                      <input
                        type="checkbox"
                        id={appliance.name}
                        name={appliance.name}
                        value={appliance.name}
                        onChange={handleChange}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="checkbox-container">
              <h3>Included ingredients</h3>
              <AsyncSelect
                placeholder="search or add ingredients"
                loadOptions={loadOptions}
                onChange={handleIngredientChange}
              />

              {selectedIngredients.length > 0 && (
                <div className="ingredient-basket">
                  <h2>Your Ingredients:</h2>
                  <ul>
                    {selectedIngredients.map((ingredient, index) => (
                      <li key={index}>
                        {ingredient.label}
                        <button onClick={() => handleDeleteIngredient(index)}>
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <h3>Excluded ingredients</h3>
              <AsyncSelect
                placeholder="search or add ingredients"
                loadOptions={loadOptions}
                onChange={handleexceptIngredientChange}
              />

              {exceptIngredients.length > 0 && (
                <div className="ingredient-basket">
                  <h2>Except Ingredients:</h2>
                  <ul>
                    {exceptIngredients.map((ingredient, index) => (
                      <li key={index}>
                        {ingredient.label}
                        <button
                          onClick={() => handleDeleteIngredientexcept(index)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {isLoading ? (
            <div className={`loader-overlay ${isLoading ? "active" : ""}`}>
              <div className="loader-text">Cooking the recipe ...</div>
              <div className="loader" />
            </div>
          ) : ingredients.length > 0 && instructions.length > 0 ? (
            <div className="recipe-container">
              <div className="ingredients-container">
                <h2>Ingredients:</h2>
                {ingredients.map((ingredient, index) => (
                  <div key={index} className="ingredient-item">
                    <input type="checkbox" id={`ingredient-${index}`} />
                    <label htmlFor={`ingredient-${index}`}>{ingredient}</label>
                  </div>
                ))}
              </div>
              <div className="instructions-container">
                <h2>Instructions:</h2>
                {instructions.map((instruction, index) => (
                  <div key={index} className="instruction-item">
                    <input type="checkbox" id={`instruction-${index}`} />
                    <label htmlFor={`instruction-${index}`}>
                      {instruction}
                    </label>
                  </div>
                ))}
              </div>
              <div className="nutrition-container">
                <h2>Nutrition Information:</h2>
                {nutritionInfo &&
                "error" in nutritionInfo &&
                nutritionInfo.error === "low_quality" ? (
                  <div className="nutrition-item">
                    Dish is too generic to be analyzed.
                  </div>
                ) : (
                  Object.keys(nutritionInfo).map((key, index) => {
                    const value = nutritionInfo[key];

                    // Exclude certain keys from being displayed
                    const excludedKeys = [
                      "dietLabels",
                      "healthLabels",
                      "cautions",
                      "ingredients",
                    ];
                    if (excludedKeys.includes(key)) {
                      return null;
                    }

                    if (
                      typeof value === "object" &&
                      !Array.isArray(value) &&
                      "value" in value &&
                      "unit" in value
                    ) {
                      // Special handling for nested object
                      return (
                        <div key={index} className="nutrition-item">
                          <strong>{key}:</strong> {value.value} {value.unit}
                        </div>
                      );
                    } else if (Array.isArray(value)) {
                      return (
                        <div key={index} className="nutrition-item">
                          <strong>{key}:</strong> {value.join(", ")}
                        </div>
                      );
                    } else if (
                      typeof value === "object" &&
                      !Array.isArray(value)
                    ) {
                      // Handle nested objects
                      return Object.keys(value).map(
                        (nestedKey, nestedIndex) => {
                          const nestedValue = value[nestedKey];
                          if (
                            typeof nestedValue === "object" &&
                            "value" in nestedValue &&
                            "unit" in nestedValue
                          ) {
                            return (
                              <div
                                key={`${key}-${nestedIndex}`}
                                className="nutrition-item"
                              >
                                <strong>{`${key} - ${nestedKey}:`}</strong>{" "}
                                {nestedValue.value} {nestedValue.unit}
                              </div>
                            );
                          } else if (
                            nestedKey === "error" &&
                            nestedValue === "low_quality"
                          ) {
                            return (
                              <div
                                key={`${key}-${nestedIndex}`}
                                className="nutrition-item"
                              >
                                <strong>{`${key} - ${nestedKey}:`}</strong> Dish
                                is too generic too be analyzed.
                              </div>
                            );
                          } else {
                            return null;
                          }
                        }
                      );
                    } else {
                      return (
                        <div key={index} className="nutrition-item">
                          <strong>{key}:</strong> {value}
                        </div>
                      );
                    }
                  })
                )}
              </div>
            </div>
          ) : isProcessing ? (
            <div>No recipe found.</div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </>
  );
}

export default App;
